import './RAPillButton.scss';

import React from 'react';
import PropTypes from 'prop-types';
const classnames = require('classnames');
import { isInternetExplorer, isWindows } from 'utilities/browser';

class RAPillButton extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        const { changeOption, disabled, value } = this.props;

        if (disabled) return;

        changeOption(value);
    }

    format(value) {
        const { formatter } = this.props;

        return formatter ? formatter(value) : value;
    }

    render() {
        const { disabled, selectedOption, value } = this.props;

        const msieCondition = isInternetExplorer() && isWindows();
        const currentClassName = classnames(
            'ra-pill-button',
            {
                'ra-pill-button--active': selectedOption === value,
                'ra-pill-button--disabled': disabled,
            },
            { msie: msieCondition }
        );

        return (
            <a className={currentClassName} onClick={this.handleClick}>
                {this.format(value)}
            </a>
        );
    }
}

RAPillButton.propTypes = {
    changeOption: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    formatter: PropTypes.func.isRequired,
    selectedOption: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

module.exports = RAPillButton;
